module.exports = __webpack_public_path__ + "82ceebeae05b1e4adf05973e4bd7d6cb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/paint-brush.png
// module id = 2081
// module chunks = 0